<template>
    <div class="divide-y divide-primary-20 -mt-32 -mb-48">
        <profile-editor></profile-editor>
        <user-preferences></user-preferences>
        <feature feature-key="calendar" sub-key="user-setting">
            <manage-calendars></manage-calendars>
        </feature>
        <email-signatures></email-signatures>
        <template v-if="!currentUser.is_sso_user">
            <password-editor></password-editor>
            <two-factor-auth></two-factor-auth>
        </template>
        <user-api-tokens></user-api-tokens>
    </div>
</template>

<script>
import ConfigureTwoFactorAuth from '../components/ConfigureTwoFactorAuth.vue';
import PasswordEditor from '../components/PasswordEditor.vue';
import ProfileEditor from '../components/ProfileEditor.vue';
import UserPreferences from '../components/UserPreferences.vue';
import UserApiTokens from "../components/UserApiTokens.vue";
import EmailSignatures from '../components/EmailSignatures.vue';
import ManageCalendars from '../components/ManageCalendars.vue';
import ManageCalendarAvailability from '../components/ManageCalendarAvailability.vue';
import { mapState } from 'pinia';
import {useAuthenticationStore} from '../state/modules/authentication';
import Feature from '../components/Feature.vue';

export default {
    components: {
        Feature,
        ManageCalendars,
        ManageCalendarAvailability,
        UserApiTokens,
        'profile-editor': ProfileEditor,
        'two-factor-auth': ConfigureTwoFactorAuth,
        'password-editor': PasswordEditor,
        'user-preferences': UserPreferences,
        'email-signatures': EmailSignatures,
    },
    computed: {
        ...mapState(useAuthenticationStore, ['currentUser'])
    }
}
</script>
